// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Figure';



// WEBPACK FOOTER //
// ./components/Figure/index.js